import './style.scss';
import { useAuth } from 'react-oidc-context';
import { useHistory } from 'react-router-dom';

function Header({ isLoginPage }) {
  const auth = useAuth();
  const user = sessionStorage.user ? JSON.parse(sessionStorage.user) : null;
  const history = useHistory();

  const isAdmin = auth?.user?.profile?.usertype === '0' && !user;

  return (
    <header className="header">
      <svg
        className="header__logo-container"
        width="173"
        height="121"
        viewBox="0 0 173 121"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-94 -11C-94 -80.7452 -52.4907 -143 39.5 -143C131.528 -143 173 -80.7452 173 -11C173 58.7452 131.491 121 39.5 121C-52.4907 121 -94 58.7452 -94 -11Z"
          fill="#003025"
        />
      </svg>
      <svg
        className="header__logo"
        width="92"
        height="24"
        viewBox="0 0 92 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M86.1968 10.9373H81.3633C81.3633 10.5834 81.6312 8.65625 83.7801 8.65625C85.9299 8.65625 86.1968 10.5834 86.1968 10.9373ZM83.7785 16.2851C82.3923 16.2851 81.4647 15.184 81.3341 13.6377H91.2147C91.2147 8.33899 89.1355 5.32324 83.7785 5.32324C78.7085 5.32324 76.4214 8.69288 76.4214 12.4703C76.4214 16.2457 78.7085 19.6163 83.7785 19.6163C86.8464 19.6163 89.8896 18.2517 90.9287 15.3158H86.119C86.0351 15.437 85.5527 16.2851 83.7785 16.2851ZM70.9634 10.9373H66.1289C66.1289 10.5834 66.3968 8.65625 68.5457 8.65625C70.6946 8.65625 70.9634 10.5834 70.9634 10.9373ZM68.5467 16.2851C67.1605 16.2851 66.2339 15.184 66.1032 13.6377H75.983C75.983 8.33899 73.9037 5.32324 68.5467 5.32324C63.4777 5.32324 61.1906 8.69288 61.1906 12.4703C61.1906 16.2457 63.4777 19.6163 68.5467 19.6163C71.6146 19.6163 74.6587 18.2517 75.697 15.3158H70.8872C70.8043 15.437 70.3219 16.2851 68.5467 16.2851ZM21.495 15.8418H21.4921H21.4873C19.8037 15.8389 19.2812 14.4118 19.2812 12.4722C19.2812 10.5315 19.8037 9.10349 21.4873 9.10156H21.4921H21.495C23.1776 9.10349 23.701 10.5315 23.701 12.4722C23.701 14.4118 23.1776 15.8389 21.495 15.8418ZM21.4909 5.32422C16.4209 5.32422 14.1328 8.69385 14.1328 12.4712C14.1328 16.2467 16.4209 19.6173 21.4909 19.6173C26.559 19.6173 28.847 16.2467 28.847 12.4712C28.847 8.69385 26.559 5.32422 21.4909 5.32422ZM43.4338 19.2744H38.4687V17.5443C37.5067 18.907 36.0776 19.6157 34.0222 19.6157C31.6044 19.6157 29.3945 18.1204 29.3945 15.0008V5.66406H34.5417V12.8486C34.5417 14.3343 34.7238 15.472 36.2321 15.472C37.1168 15.472 38.2856 15.0248 38.2856 12.8486V5.66406H43.4338V19.2744ZM9.93691 20.06C11.1687 16.6971 15.2157 5.66309 15.2157 5.66309H9.92357L7.49725 13.5698L5.4704 5.66309H0L4.88408 18.5964C4.33113 19.9398 3.6571 20.1571 2.91062 20.1571C2.52832 20.1571 1.78565 20.0514 1.78565 20.0514V23.6027C1.78565 23.6027 3.36537 23.9989 4.34925 23.9989C6.86613 23.9989 9.02931 22.5392 9.93691 20.06ZM49.6997 12.8487C49.6997 13.9199 49.9457 15.4721 52.638 15.4721C53.5732 15.4721 55.0033 15.1566 55.0033 13.7661C55.0033 12.7967 54.1977 12.5352 51.001 11.6168C48.0618 10.7773 44.7079 9.9637 44.7079 6.18824C44.7079 1.86272 48.3736 0 52.1956 0C56.2264 0 59.7863 1.54634 59.9426 6.11035H54.5352C54.5352 6.11035 54.5561 5.94591 54.5561 5.84397C54.5561 4.76307 53.4073 4.14281 52.1699 4.14281C51.39 4.14281 50.1163 4.35341 50.1163 5.40257C50.2193 6.74023 52.8715 7.02873 55.4971 7.76247C58.1227 8.49718 60.7225 9.73001 60.7225 13.1641C60.7225 18.0426 56.277 19.6158 52.1441 19.6158C49.979 19.6158 43.9805 18.8061 43.9805 12.8487H49.6997Z"
          fill="white"
        />
      </svg>
      {isAdmin && (
        <ul className="header__profile">
          <li
            className="header__profile__each"
            onClick={() => {
              history.push('/');
            }}
          >
            <svg
              width="24"
              height="24"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
            >
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="white"
                stroke-width="3"
              >
                <path
                  stroke-linecap="square"
                  d="M31.714 15.918v17.131c0 .996-.803 1.803-1.794 1.803H10.179a1.799 1.799 0 0 1-1.795-1.803V15.918"
                />
                <path
                  stroke-linecap="square"
                  d="M17.357 33.05v-6.312c0-.996.804-1.804 1.795-1.804h1.795c.99 0 1.794.808 1.794 1.804v6.311"
                />
                <path
                  stroke-linecap="round"
                  d="M3.406 18.144L19.41 7.23a1.8 1.8 0 0 1 2.067.027l15.112 10.887"
                />
              </g>
            </svg>
            <p>Hjem</p>
          </li>
          <li
            className="header__profile__each"
            onClick={() => {
              history.push('/mobil/users');
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.7998 20.3999C4.7998 20.3999 4.95487 15.3599 9.1833 15.3599C10.1421 15.3599 11.1483 15.3599 12.1343 15.3599C13.4354 15.3599 14.3498 15.3599 15.5044 15.3599C19.4334 15.3599 19.7998 20.3999 19.7998 20.3999"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0113 13.1201C14.7196 13.1201 16.9151 10.989 16.9151 8.3601C16.9151 5.73122 14.7196 3.6001 12.0113 3.6001C9.30295 3.6001 7.10742 5.73122 7.10742 8.3601C7.10742 10.989 9.30295 13.1201 12.0113 13.1201Z"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
            <p>Brugere</p>
          </li>
        </ul>
      )}
      {user && (
        <ul className="header__profile">
          <li
            className="header__profile__each"
            onClick={() => {
              history.push('/mobil');
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 42 42"
              width="28"
              height="28"
            >
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="white"
                stroke-width="2"
              >
                <path
                  stroke-linecap="square"
                  d="M31.714 15.918v17.131c0 .996-.803 1.803-1.794 1.803H10.179a1.799 1.799 0 0 1-1.795-1.803V15.918"
                />
                <path
                  stroke-linecap="square"
                  d="M17.357 33.05v-6.312c0-.996.804-1.804 1.795-1.804h1.795c.99 0 1.794.808 1.794 1.804v6.311"
                />
                <path
                  stroke-linecap="round"
                  d="M3.406 18.144L19.41 7.23a1.8 1.8 0 0 1 2.067.027l15.112 10.887"
                />
              </g>
            </svg>
            <p>Hjem</p>
          </li>
          <li
            className="header__profile__each"
            onClick={() => {
              history.push('/mobil/order');
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
              <circle
                cx="26"
                cy="24"
                r="8.5"
                fill="none"
                stroke="white"
                stroke-width="2"
              />
              <line
                x1="31"
                y1="31"
                x2="38"
                y2="39"
                stroke="white"
                stroke-width="2"
              />
            </svg>
            <p>Søg ordre</p>
          </li>
          <li className="header__profile__each">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.7998 20.3999C4.7998 20.3999 4.95487 15.3599 9.1833 15.3599C10.1421 15.3599 11.1483 15.3599 12.1343 15.3599C13.4354 15.3599 14.3498 15.3599 15.5044 15.3599C19.4334 15.3599 19.7998 20.3999 19.7998 20.3999"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0113 13.1201C14.7196 13.1201 16.9151 10.989 16.9151 8.3601C16.9151 5.73122 14.7196 3.6001 12.0113 3.6001C9.30295 3.6001 7.10742 5.73122 7.10742 8.3601C7.10742 10.989 9.30295 13.1201 12.0113 13.1201Z"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
            <p>{user?.salesmanname}</p>
          </li>
          <li
            className="header__profile__each"
            onClick={() => {
              sessionStorage.removeItem('user');
              history.push('/');
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2002 15.1202L16.2002 17.7202C16.2002 18.8689 15.3176 19.8002 14.2288 19.8002L4.37162 19.8002C3.28283 19.8002 2.4002 18.8689 2.4002 17.7202L2.4002 6.28019C2.4002 5.13144 3.28284 4.20019 4.37163 4.20019L14.2288 4.2002C15.3176 4.2002 16.2002 5.13144 16.2002 6.2802L16.2002 8.8802"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M21.6002 12L19.2002 15"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.2002 9L21.6002 12"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.5998 12L10.7998 12"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <p>Log ud</p>
          </li>
        </ul>
      )}
      {isLoginPage && auth.isAuthenticated && (
        <ul className="header__profile">
          <li
            className="header__profile__each"
            onClick={() =>
              auth.signoutRedirect({
                extraQueryParams: {
                  TargetResource: window.location.origin,
                },
              })
            }
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2002 15.1202L16.2002 17.7202C16.2002 18.8689 15.3176 19.8002 14.2288 19.8002L4.37162 19.8002C3.28283 19.8002 2.4002 18.8689 2.4002 17.7202L2.4002 6.28019C2.4002 5.13144 3.28284 4.20019 4.37163 4.20019L14.2288 4.2002C15.3176 4.2002 16.2002 5.13144 16.2002 6.2802L16.2002 8.8802"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M21.6002 12L19.2002 15"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.2002 9L21.6002 12"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.5998 12L10.7998 12"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <p>Butiks Logud</p>
          </li>
        </ul>
      )}
    </header>
  );
}

export default Header;
